function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "54",
  height: "48",
  viewBox: "0 0 54 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-gift",
  d: "M0 0h53.746v47.94H0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-gift",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-gift"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.7 6.918C9.51 3.075 12.907 0 17.024 0c4.685 0 7.62 3.782 8.796 5.06l.01.009c.6.65 1.62.65 2.22 0l.01-.01C29.232 3.782 32.171 0 36.853 0c4.116 0 7.512 3.075 8.322 6.918.19.903-.483 1.757-1.398 1.757h-33.68c-.915 0-1.588-.854-1.397-1.757zM50.888 19.68h-2.744V44.829c0 .128-.102.23-.229.23H37.14V15.421h13.747v4.259zM20.943 45.06H32.82V15.42H20.943v29.64zm-4.536 0H5.832a.229.229 0 01-.228-.231V19.68H2.859v-4.26h13.548v29.64zm34.595-32.52H2.745A2.753 2.753 0 000 15.307v4.49a2.753 2.753 0 002.745 2.764v22.269c0 1.718 1.382 3.11 3.087 3.11h42.082c1.706 0 3.088-1.392 3.088-3.11V22.56a2.755 2.755 0 002.744-2.765v-4.49a2.755 2.755 0 00-2.744-2.764z",
  fill: "currentColor",
  mask: "url(#mask-gift)"
}))));